export default "__VITE_ASSET__ClmeuL3M__"